import React from 'react'
import '../styles/contact.css'
import emailjs from '@emailjs/browser'
import { NavLink } from 'react-router-dom';

function Contact() {

    const refForm = React.useRef();
    const sendEmail = (event) => {
        event.preventDefault();

        const serviceId = "service_7cpqbev"
        const templateId = "template_ti9s1h4"
        const apiKey = "kKiCXpL2G-TNi5Hei"

        emailjs.sendForm(serviceId, templateId, refForm.current, {
            publicKey: apiKey
        })
            .then(
                () => {
                    window.location.href = '/contact';

                },
                (error) => {
                    console.log('FAILED...', error.text);

                },
            );
    };

    return (


        <div className='contact-container'>

            {/* ZOOM CONTAINER TEAM */}
            <div className='zoom-container-contact pt-2 d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-container'></div>
                <div className='text-center mt-5'>
                    <span className='zoom-container-span-team'>SERVICIO AL</span>
                    <span className='zoom-container-span-team fw-bold'>CLIENTE</span>
                </div>
            </div>

            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>

            <div className='container-xxl pt-5 pb-5'>
                <div className='row'>

                    <div className="col-lg-4">

                        {/* DATOS DE CONTACTO */}
                        <div className="contact-info">

                            <div className="contact-section">
                                <i className="bi bi-geo-alt"></i>
                                <div className="contact-section-int">
                                    <h4>Dirección:</h4>
                                    <p>Calle 44 #67A-55 Salitre el greco, Bogotá</p>
                                </div>
                            </div>

                            <div className="contact-section mt-3">
                                <i className="bi bi-envelope"></i>
                                <div className="contact-section-int">
                                    <h4>Correo:</h4>
                                    <p>servicioalcliente@defiendeme.com</p>
                                </div>
                            </div>

                            <div className="contact-section mt-3">
                                <i className="bi bi-phone"></i>
                                <div className="contact-section-int">
                                    <h4>Teléfonos:</h4>
                                    <p>310 532 6827 - 321 407 7576 - 350 601 5410</p>
                                </div>
                            </div>

                        </div>

                        {/* MAPA */}
                        <div data-aos="fade-up" className="maps pt-4">
                            <iframe style={{ border: 0, width: "100%", height: "200px", borderRadius: "15px", }} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.6568845686143!2d-74.10401462596313!3d4.655133742052853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b97cc2bcab9%3A0x2ee1eada9f2b43fb!2sCl.%2044%20%2367a-55%20Piso%203%2C%20Bogot%C3%A1!5e0!3m2!1ses!2sco!4v1710866236403!5m2!1ses!2sco"
                                title="Defiendeme"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>

                    {/* Formulario */}
                    <div className='col-lg-8 contact-form-container'>
                        <form className='contact-form d-flex flex-column' action="" ref={refForm} onSubmit={sendEmail} htmlFor="">

                            <div className='contact-form-bg'>
                                <input type="text" name="to_name" className="form-control" id="name" placeholder="Nombre" required />
                            </div>

                            <div className='contact-form-bg'>
                                <input type="email" className="form-control" name="email" id="email" placeholder="Correo electrónico" required />
                            </div>

                            <div className='contact-form-bg'>
                                <input type="text" className="form-control" name="asunto" id="subject" placeholder="Asunto" required />
                            </div>
                            <div className='contact-form-bg'>
                                <textarea className="form-control" name="message" rows={5} placeholder="Mensaje" required></textarea>
                            </div>

                            <div className="form-check" style={{ padding: "17px", fontSize: "15px" }}>
                                <input type="checkbox" className="form-check-input" style={{ height: "15px", borderColor: "#128140" }} id="exampleCheck1" required />
                                <label className="form-check-label" htmlFor="exampleCheck1">Autorizo a Funeral Home el tratamiento de mis datos personales según la
                                    <NavLink to="/politica-privacidad" className="text-decoration-none"> Política de tratamiento de datos.</NavLink>
                                </label>
                            </div>

                            <div className="mt-3 text-center" ><button type="submit" className='form-boton'>Enviar mensaje</button></div>
                        </form>
                    </div>

                </div>
            </div >
        </div >
    )
}

export default Contact
